'use strict';

/**
 * @classname TabNav
 * @classdesc タブナビ
 */
export default class Tab {
	/**
	 * @constructor
	 * @param {jQuery} $e - .tab__navs--top
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		const num = $e.find('.btn').length;
		const $btn = $e.find('.btn');
		const space = num - 1;
		const spaceLength = space * 10;
		const width = `calc((100% - ${spaceLength}px) / ${num})`;
		$btn.css('width', width);
	};
};
